import React from 'react';
import { Chip, List, Stack, Typography } from '@mui/material';
import { paths } from '@/app/routes';
import FolioLink from '@/components/FolioLink';
import { useFolioDrawerContext } from '@/components/Drawers/FolioDrawer/FolioDrawerContext';
import { isModifiedClick } from '@/utils/navigation';

const AssociatedCompanies = ({ associations }) => {
	const { onClose } = useFolioDrawerContext();
	const validAssociations = associations.filter(
		({ relationshipCompanyId }) => relationshipCompanyId
	);

	return (
		<>
			<Typography variant='subtitle1'>Associated companies</Typography>

			{validAssociations.length > 0 ? (
				<List>
					{validAssociations.map(
						({ relationshipCompanyId, companyName, isPrimary }) => (
							<Stack
								key={relationshipCompanyId}
								direction='row'
								spacing={1}
								alignItems='center'
								sx={{ mb: 1.5 }}
							> 
								<FolioLink
									to={`${paths.companies}/${relationshipCompanyId}`}
									onClick={(event) => {
										if (isModifiedClick(event)) return;
										onClose(event);
									}}
								>
									<Typography
										sx={(theme) => ({
											color: theme.palette.primary.main,
											fontWeight: 600,
											'&:hover': {
												textDecoration: 'underline',
											},
										})}
									>
										{companyName}
									</Typography>
								</FolioLink>

								{isPrimary && (
									<Chip size='small' label='Primary' color='primary' />
								)}
							</Stack>
						)
					)}
				</List>
			) : (
				<Typography variant='body2' color='text.secondary'>
					No companies associated with this contact.
				</Typography>
			)}
		</>
	);
};
export default AssociatedCompanies;

